function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import PropTypes from 'prop-types';
import range from 'lodash/range';
import flattenDeep from 'lodash/flattenDeep';
import Select from '@domain-group/fe-co-select';
import { Button } from '@domain-group/fe-co-allhomes-design-system';
import * as styles from './allhomes-search-price-range.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
class AllhomesSearchPriceRange extends React.Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "onChangePriceLower", _ref => {
      var value = _ref.value;
      return this.props.onChange(_objectSpread(_objectSpread({}, this.props.selectedRange), {}, {
        min: value
      }));
    });
    _defineProperty(this, "onChangePriceUpper", _ref2 => {
      var value = _ref2.value;
      return this.props.onChange(_objectSpread(_objectSpread({}, this.props.selectedRange), {}, {
        max: value
      }));
    });
    _defineProperty(this, "onClear", () => {
      this.props.onChange({});
      this.props.onClearClick();
    });
    _defineProperty(this, "populatePriceRange", () => {
      var numberRanges = flattenDeep(this.props.priceRanges.map(object => range(object.start, object.end, object.step)));
      var maxValue = Math.max(...numberRanges);
      var priceRanges = numberRanges.map(number => {
        var currency = number.toLocaleString('en-AU', {
          style: 'currency',
          currency: 'AUD',
          minimumFractionDigits: 0
        });
        if (number === 0) {
          return {
            value: number,
            label: 'Any'
          };
        }
        if (number === maxValue) {
          return {
            value: number,
            label: "".concat(currency, "+")
          };
        }
        return {
          value: number,
          label: currency
        };
      });
      return priceRanges;
    });
  }
  render() {
    return ___EmotionJSX("section", {
      css: styles.container
    }, ___EmotionJSX("div", {
      css: styles.label
    }, "Price"), !this.props.embedded && ___EmotionJSX(Button, {
      css: styles.clear,
      appearance: "ghost",
      onClick: this.onClear
    }, "Clear"), ___EmotionJSX("div", {
      css: styles.wrapper
    }, ___EmotionJSX("div", {
      css: styles.selectContainer
    }, ___EmotionJSX(Select, {
      css: styles.select({
        embedded: this.props.embedded
      }),
      label: "select-from",
      options: this.populatePriceRange(),
      onChange: this.onChangePriceLower,
      value: this.props.selectedRange.min || 0,
      defaultValue: this.props.selectedRange.min || 0,
      labelHidden: true
    })), ___EmotionJSX("span", {
      css: styles.selectSeparator
    }, "to"), ___EmotionJSX("div", {
      css: styles.selectContainer
    }, ___EmotionJSX(Select, {
      css: styles.select({
        embedded: this.props.embedded
      }),
      name: "select-to",
      options: this.populatePriceRange(),
      onChange: this.onChangePriceUpper,
      value: this.props.selectedRange.max || 0,
      defaultValue: this.props.selectedRange.max || 0,
      labelHidden: true
    }))), !this.props.embedded && ___EmotionJSX("div", {
      css: styles.applyButton
    }, ___EmotionJSX(Button, {
      onClick: this.props.onButtonClick
    }, "Apply")));
  }
}
AllhomesSearchPriceRange.propTypes = {
  selectedRange: PropTypes.shape({
    min: PropTypes.number,
    max: PropTypes.number
  }),
  priceRanges: PropTypes.arrayOf(PropTypes.shape({
    start: PropTypes.number,
    end: PropTypes.number,
    step: PropTypes.number
  })),
  onChange: PropTypes.func,
  onButtonClick: PropTypes.func,
  onClearClick: PropTypes.func,
  embedded: PropTypes.bool
};
AllhomesSearchPriceRange.defaultProps = {
  selectedRange: {},
  priceRanges: [],
  embedded: false,
  onChange: () => {},
  onButtonClick: () => {},
  onClearClick: () => {}
};
export default AllhomesSearchPriceRange;